import Axios from "axios";

class FuncionarioFolhaPagamentoVerbaDataService {
  getAll() {
    return Axios.get("funcionarioFolhaPagamentoVerbas");
  }

  getPage(params) {
    return Axios.get("funcionarioFolhaPagamentoVerbas/page", { params });
  }

  create(params) {
    return Axios.post("funcionarioFolhaPagamentoVerbas", params);
  }

  update(params) {
    console.log(params);
    return Axios.put("funcionarioFolhaPagamentoVerbas/" + params.id, params);
  }

  find(id) {
    return Axios.get(`funcionarioFolhaPagamentoVerbas/${id}`);
  }

  delete(id) {
    return Axios.delete(`funcionarioFolhaPagamentoVerbas/${id}`);
  }

  // Configuração para o cálculo da folha (módulo CFP).
  getCalculo() {
    return Axios.get("funcionarioFolhaPagamentoVerbas/calculo");
  }

  getCatalogosCalculo() {
    return Axios.get("funcionarioFolhaPagamentoVerbas/calculo/catalogos");
  }

  // Papéis calculados pelo motor sem verba ativa, com a verba sugerida para cada um.
  getPapeisSemVerba() {
    return Axios.get("funcionarioFolhaPagamentoVerbas/calculo/papeisSemVerba");
  }

  findCalculo(id) {
    return Axios.get(`funcionarioFolhaPagamentoVerbas/${id}/calculo`);
  }

  createCalculo(data) {
    return Axios.post("funcionarioFolhaPagamentoVerbas/calculo", data);
  }

  updateCalculo(data) {
    return Axios.put(
      `funcionarioFolhaPagamentoVerbas/${data.id}/calculo`,
      data
    );
  }

  getPropostaPadrao() {
    return Axios.get("funcionarioFolhaPagamentoVerbas/calculo/padrao");
  }

  aplicarPadrao(escolhidas) {
    return Axios.post(
      "funcionarioFolhaPagamentoVerbas/calculo/padrao",
      escolhidas
    );
  }
}

export default new FuncionarioFolhaPagamentoVerbaDataService();
